var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container1"},[_c('page-header'),_c('payment-result',{attrs:{"isPayFail":""}}),_c('footer-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }